export default __webpack_public_path__ + "static/media/business.ea305c55.png";